import React from "react";
import "./edit-shift-modal.css";

const EditTime = (props) => {
  const {
    disabled = false,
    startTime,
    endTime,
    onChange,
    setStartTime,
    setEndTime,
    timeValidationError,
  } = props;
  return (
    <div className="edit-time-container">
      <div className="edit-time-input-container">
        <div className="input-container input-margin-right">
          <span className="input-label">Start time</span>
          <input
            disabled={disabled}
            aria-label="Input Start Time"
            className="shift-time-input"
            data-val-regex-pattern="^(0[1-9]|1[0-2]):[0-5][0-9] (am|pm|AM|PM)$"
            name="startTime"
            type="time"
            value={startTime}
            onChange={(event) => {
              setStartTime(event.currentTarget.value);
              onChange(event, "startTime");
            }}
          ></input>
        </div>
        <div className="input-container">
          <span className="input-label">End time</span>
          <input
            disabled={disabled}
            aria-label="Input End Time"
            className="shift-time-input"
            data-val-regex-pattern="^(0[1-9]|1[0-2]):[0-5][0-9] (am|pm|AM|PM)$"
            name="endTime"
            type="time"
            value={endTime}
            onChange={(event) => {
              setEndTime(event.currentTarget.value);
              onChange(event, "endTime");
            }}
          ></input>
        </div>
      </div>
      {
        !disabled ? (
          <div className="validation-error-container">
            {
              timeValidationError ? (
                <span className="validation-error">
                {timeValidationError}
              </span>
              ) : null
            }
          </div>
        ) : null
      }
    </div>
  );
}

export default EditTime;
